import type { ISoundPlayer } from '@/features/scanner/alerts/audio/sound-player'
import { usePriceAlertNotifications } from './use-price-alert-notifications'

/**
 * Mounted once in AppLayout behind REALTIME_WEBSOCKET_ENABLED, so a fired alert toasts
 * (and pings) wherever the user is, not only while the Price Alerts panel is open.
 */
export function PriceAlertNotifier({ sound }: { sound: ISoundPlayer }) {
  usePriceAlertNotifications(sound)
  return null
}
